
import React from 'react';
import { FormField, FormItem, FormDescription } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { useFormContext } from 'react-hook-form';

export const SubmissionField: React.FC = () => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name="submitted_on_time"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
          <Checkbox
            checked={field.value}
            onCheckedChange={field.onChange}
          />
          <div className="space-y-1 leading-none">
            <FormDescription>
              รายงานนี้ถูกส่งตรงตามเวลาที่กำหนด
            </FormDescription>
          </div>
        </FormItem>
      )}
    />
  );
};
